import { render, staticRenderFns } from "./PageExploreCertificates.vue?vue&type=template&id=024d520c&scoped=true&"
import script from "./PageExploreCertificates.vue?vue&type=script&lang=js&"
export * from "./PageExploreCertificates.vue?vue&type=script&lang=js&"
import style0 from "./PageExploreCertificates.vue?vue&type=style&index=0&id=024d520c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d520c",
  null
  
)

export default component.exports